module.exports = __webpack_public_path__ + "img/index1.6cae5c34.png";